export default __webpack_public_path__ + "static/media/plus-sign.7beff103.svg";